const image = [
  "M3.58 4.58a1.33 1.33 0 1 1 0 2.67 1.33 1.33 0 0 1 0-2.67z",
  "M2 3.33h12c.37 0 .67.3.67.67v5.3l-3.51-3.51a1.17 1.17 0 0 0-1.65 0L6.33 8.96l-.84-.84a1.17 1.17 0 0 0-1.65 0l-2.5 2.5V4c0-.37.3-.67.66-.67zM14 2H2a2 2 0 0 0-2 2v8l.01.11a.5.5 0 0 0 .03.24A2 2 0 0 0 2 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
];
export {
  image
};
//# sourceMappingURL=image.js.map
